import React from "react";
import styles from "./styles.module.scss";
import ReactDatePicker from "react-datepicker";
import i18n from "app/i18n";
import { DateTime } from "luxon";
import { cls } from "app/utils";

interface ISessionsDatePickerProps {
  date: DateTime;
  handleDecreaseMonth: (decreaseMonth?: () => void) => void;
  handleIncreaseMonth: (increaseMonth?: () => void) => void;
  excludeDates?: Date[];
  /**
   * The complement of excludeDates: when given, only these days are selectable.
   * The facility By Date calendar knows which days *have* availability rather
   * than which ones lack it, so it allows-lists instead (CN-2652).
   */
  includeDates?: Date[];
  handleChangeDate: (value: DateTime) => void;
  className?: string;
}

const SessionsDatePicker = ({
  date,
  handleDecreaseMonth,
  handleIncreaseMonth,
  excludeDates,
  includeDates,
  handleChangeDate,
  className,
}: ISessionsDatePickerProps) => {
  const CustomHeader = ({ date, decreaseMonth, increaseMonth }) => {
    return (
      <div className={cls(styles.header, className)}>
        <div
          className={styles.date_arrow}
          style={{ transform: "rotate(90deg)" }}
          onClick={() => handleDecreaseMonth(decreaseMonth)}
        >
          {/* No spaces around the glyph: they are text nodes with width, and they
              push it off the centre of the circle. */}
          <span>
            <i className="ico ico-chevron" />
          </span>
        </div>
        <p>{date.toLocaleString({ month: "long", year: "numeric" })}</p>
        <div
          className={styles.date_arrow}
          style={{ transform: "rotate(-90deg)" }}
          onClick={() => handleIncreaseMonth(increaseMonth)}
        >
          {/* No spaces around the glyph: they are text nodes with width, and they
              push it off the centre of the circle. */}
          <span>
            <i className="ico ico-chevron" />
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.date_picker}>
      <ReactDatePicker
        locale={i18n.language}
        selected={date.toJSDate()}
        onChange={(value: Date): void =>
          handleChangeDate(DateTime.fromJSDate(value))
        }
        dateFormat="MMMM, d, yyyy"
        useWeekdaysShort={true}
        renderCustomHeader={({
          date: selDate,
          decreaseMonth,
          increaseMonth,
        }): React.ReactElement => (
          <CustomHeader
            increaseMonth={increaseMonth}
            decreaseMonth={decreaseMonth}
            date={DateTime.fromJSDate(selDate)}
          />
        )}
        minDate={new Date()}
        excludeDates={excludeDates}
        includeDates={includeDates}
        calendarClassName={styles.day_picker}
        disabledKeyboardNavigation
        inline
      />
    </div>
  );
};

export default SessionsDatePicker;
